const triggerCartUpdatedFlag = (cartFlag: string) => {
    localStorage.setItem(cartFlag, Date.now().toString());
};

export default triggerCartUpdatedFlag;
